module.exports = __webpack_public_path__ + "img/serviceTitle.ab55c9db.png";